import { EXAMPLE_ARROW_GUTTER } from "@saas/shared/components/ExampleArrow";

// 样片区按自身宽度（容器查询，不看视口）排：放得下才左右排（原图 → 结果），放不下上下排；
// 图跟着容器缩，结果图永远完整。之前写死 md 起左右排 + 固定尺寸，工作台右栏窄时结果图被裁掉一半（10/20）。
// 尺寸上限还是原来三档（手机 224/128、sm 256/160、高屏 288/192），够宽时长相不变。
// 左右排宽度 = n 张原图 + (n-1) 个「+」（各约 48）+ 两个间距和箭头（96）+ 结果图，原图不超过结果图 0.625；
// 阈值取结果图还有 190 多的宽度：1 张 @md（28rem），2 张 @xl（36rem）。样片最多 2 张原图。
// md 起上下排时面板是一屏高（工作台右栏 ≈ 100vh − 底部模板条 200），结果图再按高度封顶，
// 免得 900–1100 宽的窗口结果图下半截在折叠线下（标题约 100 + 边距箭头 168 + 原图 0.75 + 结果 1.25 = 2 × 结果宽）。
// 骨架和真实内容共用，挂在 @container 下面用
export function getShowcaseLayout(inputCount: number) {
	const multi = inputCount > 1;
	return {
		row: [
			"flex flex-col items-center justify-center gap-6",
			"[--res-max:14rem] [--in-max:8rem] sm:[--res-max:16rem] sm:[--in-max:10rem] md:[@media(min-height:1000px)]:[--res-max:18rem] md:[@media(min-height:1000px)]:[--in-max:12rem]",
			"[--res:min(var(--res-max),100cqw)]",
			multi
				? "[--in:min(var(--in-max),calc(var(--res)*0.625),calc((100cqw_-_48px)/2))] md:@max-xl:[--res:min(var(--res-max),100cqw,max(8rem,calc((100vh_-_468px)/2)))] @xl:flex-row @xl:gap-8 @xl:[--res:min(var(--res-max),calc((100cqw_-_144px)/2.25))]"
				: "[--in:min(var(--in-max),calc(var(--res)*0.625))] md:@max-md:[--res:min(var(--res-max),100cqw,max(8rem,calc((100vh_-_468px)/2)))] @md:flex-row @md:gap-8 @md:[--res:min(var(--res-max),calc((100cqw_-_96px)/1.625))]",
		].join(" "),
		inputBox:
			"w-[var(--in)] aspect-[4/5] sm:aspect-[5/6] md:[@media(min-height:1000px)]:aspect-[6/7]",
		resultBox: "w-[var(--res)] aspect-[7/9] sm:aspect-[4/5]",
		arrowRight: multi ? "hidden @xl:block" : "hidden @md:block",
		arrowDown: multi ? "@xl:hidden" : "@md:hidden",
	};
}

// 和 HistoryPreviewShowcase 真实内容同尺寸的骨架。
// 同时用作 dynamic() 的 loading 和组件挂载前的占位：之前 loading 是零高的空 div，
// 移动端内容弹出时整页下移，PSI 实验室 CLS 0.968（2026-09-27）。
// 默认样片是 2 张原图，骨架按 2 张排
export function HistoryPreviewShowcaseSkeleton() {
	const layout = getShowcaseLayout(2);
	return (
		<div className="flex flex-col items-center px-4 pt-4 sm:px-8 sm:pt-8">
			<div className="@container w-full max-w-4xl space-y-6">
				{/* Header Skeleton */}
				<div className="text-center space-y-2">
					<div className="skeleton h-4 w-24 mx-auto" />
					<div className="skeleton h-8 w-64 mx-auto" />
				</div>
				{/* 和真内容一样按宽度给两侧箭头让位，对比图才同尺寸 */}
				<div className={EXAMPLE_ARROW_GUTTER}>
					<div className="@container">
						{/* Image Comparison Skeleton */}
						<div className={layout.row}>
							<div className="flex flex-nowrap gap-4 items-center">
								<div
									className={`skeleton ${layout.inputBox} rounded-xl`}
								/>
								<div
									className={`skeleton ${layout.inputBox} rounded-xl`}
								/>
							</div>
							<div className="skeleton w-8 h-8 rounded-full" />
							<div
								className={`skeleton ${layout.resultBox} rounded-2xl`}
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
